import React, { Component } from 'react';
import axios from 'axios';
import { NavLink, Navigate } from 'react-router-dom';
import { Button, Typography, Box, TablePagination, Card, CardContent, CardActions } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Serverurl from './Apiurl';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Fab from '@mui/material/Fab';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import editIconImg from './images/edit.png'; 
import deleteIconImg from './images/delete.png';

class Termsandconditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      terms: [],
      totalItems: 0,
      page: 0,
      rowsPerPage: 5,
      tc_type: 1, // Default to Quotation (1)
      itemsPerPageOptions: [5, 10, 25, 50],
      logredirect: false,
      pagename: '',
    };
  }

  // Replace componentWillMount with componentDidMount
componentDidMount() {
  // 1. Check Login
  if (localStorage.getItem("GBuserid") == null) {
    this.setState({
      logredirect: true,
      pagename: '/Businesslogin'
    });
    return;
  }

  // 2. Read 'type' from URL parameter (e.g. ?type=2 for PO)
  const params = new URLSearchParams(window.location.search);
  const typeFromUrl = parseInt(params.get('type')) || 1; 

  // 3. Set type and fetch terms
  this.setState({ tc_type: typeFromUrl, page: 0 }, this.fetchTerms);
}
  fetchTerms = () => {
    const bu_id = localStorage.getItem("GBuserid");
    axios.get(
      Serverurl +
        "ajaxtermsconditions.php?action=getall&StartIndex=" +
        this.state.page +
        "&PageSize=" +
        this.state.rowsPerPage +
        "&tc_type=" +
        this.state.tc_type +
        "&tc_bu_id=" + bu_id  
    ).then(res => {
      const data = res.data;
      const totalItems = data?.[0]?.total ? parseInt(data[0].total) : 0;
      this.setState({ terms: data || [], totalItems });
    });
  };

  changeType = (type) => {
   // Switch between Quotation (1), Purchase Order (2) and Invoice (3)
    this.setState({ tc_type: type, page: 0 }, this.fetchTerms);
  };

  onPageChange = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchTerms);
  };

  onRowsPerPageChange = (event) => {
    this.setState(
      { rowsPerPage: parseInt(event.target.value, 10), page: 0 },
      this.fetchTerms
    );
  };

  handleDelete = (tc_id) => {
    confirmAlert({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this Terms and Conditions?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            const formData = new FormData();
            formData.append('action', 'delete');
            formData.append('tc_id', tc_id);
            formData.append('userid', localStorage.getItem("GBuserid"));

            axios.post(Serverurl + "ajaxtermsconditions.php", formData)
              .then(() => {
                this.fetchTerms();
              });
          }
        },
        { label: "No" },
      ],
    });
  };

  render() {
    if (this.state.logredirect) {
      return <Navigate to={this.state.pagename} />;
    }

    const { tc_type, terms, totalItems, page, rowsPerPage, itemsPerPageOptions } = this.state;

    return (
      <div className="formdisplay">
        
        {/* Dynamic Header */}
       <Box
  sx={{
    display: "flex",
    alignItems: "center",
    gap: 1,
    mb: 2,
  }}
>
    <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>

  <Typography variant="h4">
    Terms & Conditions
  </Typography>
</Box>


        {/* Dynamic Tabs: Switch between Quotation and PO */}
        <Box sx={{ display: 'flex', gap: 3, mb: 3 }}>
          <Typography
            onClick={() => this.changeType(1)}
            sx={{
              cursor: 'pointer',
              fontWeight: tc_type === 1 ? 600 : 400,
              color: tc_type === 1 ? '#1976d2' : 'inherit',
              borderBottom: tc_type === 1 ? '2px solid #1976d2' : 'none',
              paddingBottom: '4px'
            }}
          >
            Quotation
          </Typography>

          <Typography
            onClick={() => this.changeType(2)}
            sx={{
              cursor: 'pointer',
              fontWeight: tc_type === 2 ? 600 : 400,
              color: tc_type === 2 ? '#1976d2' : 'inherit',
              borderBottom: tc_type === 2 ? '2px solid #1976d2' : 'none',
              paddingBottom: '4px'
            }}
          >
            Purchase Order
          </Typography>
		  
		  
		{localStorage.getItem("GBuserid") !== "1" && (
  <Typography
    onClick={() => this.changeType(3)}
    sx={{
      cursor: 'pointer',
      fontWeight: tc_type === 3 ? 600 : 400,
      color: tc_type === 3 ? '#1976d2' : 'inherit',
      borderBottom: tc_type === 3 ? '2px solid #1976d2' : 'none',
      paddingBottom: '4px'
    }}
  >
    Invoice
  </Typography>
)}
		  
        </Box>

        {/* List of Terms */}
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {terms.length > 0 ? (
            terms.map(term => (
              <li key={term.tc_id} style={{ marginBottom: 16 }}>
                <Card elevation={3}>
                  <div className="cardcontent">
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        {term.tc_title}
                      </Typography>

                      <Typography variant="body2" color="text.secondary" component="div">
                        <span dangerouslySetInnerHTML={{ __html: term.tc_content }} />
                      </Typography>
                    </CardContent>
                  </div>

                  <div className="cardactionsterms">
                    <CardActions sx={{ justifyContent: 'flex-end',marginRight: '10px' }}>
                      {/* Dynamic Edit URL passing current tc_type */}
                      <a
                        href={`/AddTerms?tcid=${term.tc_id}&type=${tc_type}`}
                        
                      >
                                 <img
        src={editIconImg}
        alt="Edit"
        style={{ width: '28px', marginRight: '-10px' }}
      />
                      </a>

                      <Button 
                        className="frmthirdbtn"
						 onClick={() => this.handleDelete(term.tc_id)}
                       
                       
                      >
					               <img
        src={deleteIconImg}
        alt="Delete"
        style={{ width: '28px' }}
      />
					  </Button>
                    </CardActions>
                  </div>
                </Card>
              </li>
            ))
          ) : (
            <Typography align="center" sx={{ my: 4 }}>
              No records found 
            </Typography>
          )}
        </ul>

        {/* Pagination */}
		  {this.state.totalItems > 0 && (
        <TablePagination
          component="div"
          count={totalItems}
          page={page}
          onPageChange={this.onPageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={this.onRowsPerPageChange}
          rowsPerPageOptions={itemsPerPageOptions}
        />
)}
        {/* Dynamic Floating Add Button passing current tc_type */}
        <NavLink
          to={`/AddTerms?type=${tc_type}`}
          style={{ textDecoration: 'none' }}
        >
          <Fab
            aria-label="add"
            sx={{
              position: 'fixed',
              bottom: 30,
              right: 30,
              zIndex: 1000,
              backgroundColor: '#11408f',   
              color: '#ffffff', 
              '&:hover': {
                backgroundColor: '#0d3476', 
              },    
            }}
          >
            Add
          </Fab>
        </NavLink>

      </div>
    );
  }
}

export default Termsandconditions;